import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';

import bidStrategyTypeTemplate from './bid-strategy-type.pug';

export class BidStrategyTypeColumn extends CampaignuiBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_BidStrategy', isAllSettingsGrid }) {
    const title = i18n.getString('ColumnName_BidStrategyType');
    const property = isAllSettingsGrid ? 'BiddingScheme/Type' : 'DisplayBiddingStrategyType';

    super({
      name: 'BidStrategyType',
      property,
      title,
      sortable: 'DisplayBiddingStrategyType',
      type: 'string',
      helpId,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.schemaI18n = new SchemaI18n({ i18n });
  }

  template({ value }) {
    return bidStrategyTypeTemplate({ value, schemaI18n: this.schemaI18n });
  }
}
